module.exports = {"441202001":"端州区城东街道","441202003":"端州区城西街道","441202005":"端州区黄岗街道","441202006":"端州区睦岗街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441202.json
// module id = 1837
// module chunks = 0